webpackJsonp([134932258599989,110024142630367],{

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _devices2x = __webpack_require__(2654);
	
	var _devices2x2 = _interopRequireDefault(_devices2x);
	
	var _styleguide2x = __webpack_require__(2659);
	
	var _styleguide2x2 = _interopRequireDefault(_styleguide2x);
	
	var _styleguideSite2x = __webpack_require__(2658);
	
	var _styleguideSite2x2 = _interopRequireDefault(_styleguideSite2x);
	
	var _keynote2x = __webpack_require__(2655);
	
	var _keynote2x2 = _interopRequireDefault(_keynote2x);
	
	var _sketch2x = __webpack_require__(2657);
	
	var _sketch2x2 = _interopRequireDefault(_sketch2x);
	
	var _robot2x = __webpack_require__(2656);
	
	var _robot2x2 = _interopRequireDefault(_robot2x);
	
	var _dashboard2x = __webpack_require__(2653);
	
	var _dashboard2x2 = _interopRequireDefault(_dashboard2x);
	
	var _userflows2x = __webpack_require__(2660);
	
	var _userflows2x2 = _interopRequireDefault(_userflows2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  devices: {
	    alt: 'CSS Device: iPhone',
	    src: _devices2x2.default,
	    hasShadow: false,
	    maxWidth: 387
	  },
	  styleguide: {
	    alt: 'How to maintain a Sketch styleguide',
	    src: _styleguide2x2.default,
	    hasShadow: false,
	    maxWidth: 387
	  },
	  styleguideSite: {
	    alt: 'Marvel CSS Styleguide',
	    src: _styleguideSite2x2.default,
	    hasShadow: false,
	    maxWidth: 387
	  },
	  keynote: {
	    alt: 'Export Keynote files to Marvel',
	    src: _keynote2x2.default,
	    hasShadow: false,
	    maxWidth: 387
	  },
	  sketchPaper: {
	    alt: 'iPhone 6 Printable Sketch Paper',
	    src: _sketch2x2.default,
	    hasShadow: false,
	    maxWidth: 387
	  },
	  botBot: {
	    alt: 'BotBot: Server-Side Swift Slack Bot for Marvel',
	    src: _robot2x2.default,
	    hasShadow: false,
	    maxWidth: 387
	  },
	  dashboard: {
	    alt: 'Dashboard: Share what your team is working on',
	    src: _dashboard2x2.default,
	    hasShadow: false,
	    maxWidth: 387
	  },
	  userflows: {
	    alt: 'Userflow of a Marvel prototype',
	    src: _userflows2x2.default,
	    hasShadow: false,
	    maxWidth: 387
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 1238:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var categories = {
	  resources: {
	    id: 0,
	    name: 'Resource'
	  },
	  blogArticle: {
	    id: 1,
	    name: 'Blog Article'
	  },
	  openSource: {
	    id: 2,
	    name: 'Open Source Project'
	  },
	  experiments: {
	    id: 3,
	    name: 'Experiments'
	  }
	};
	
	exports.default = categories;
	module.exports = exports['default'];

/***/ }),

/***/ 1239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _assets = __webpack_require__(1237);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _categories = __webpack_require__(1238);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var items = [{
	  id: 0,
	  name: 'Userflows for Marvel',
	  url: 'https://userflows.marvelapp.com',
	  isExternal: true,
	  asset: _assets2.default.userflows,
	  category: _categories2.default.experiments,
	  description: 'Turn your Marvel prototypes into interactive user journeys that give you a...'
	}, {
	  id: 1,
	  name: '13 Pure CSS Mobile Devices.css',
	  url: 'https://marvelapp.github.io/devices.css/',
	  isExternal: true,
	  asset: _assets2.default.devices,
	  category: _categories2.default.openSource,
	  description: "We've created several minimal iPhone, Android, Lumia and iPad devices in pure..."
	}, {
	  id: 2,
	  name: 'Creating and Maintaining the Marvel Style Guide in Sketch',
	  url: 'https://blog.marvelapp.com/creating-maintaining-marvel-style-guide-sketch/',
	  isExternal: true,
	  asset: _assets2.default.styleguide,
	  category: _categories2.default.blogArticle,
	  description: 'The essence of digital product design lies in identifying problems, solving those and... '
	}, {
	  id: 3,
	  name: 'Mobile Devices Sketch Paper',
	  url: '/sketchpad',
	  isExternal: true,
	  asset: _assets2.default.sketchPaper,
	  category: _categories2.default.resources,
	  description: 'Need something to draw on? Download our free printable templates and bring your ideas to life.'
	}, {
	  id: 4,
	  name: 'Marvel for Keynote',
	  url: 'https://keynote.marvelapp.com',
	  isExternal: true,
	  asset: _assets2.default.keynote,
	  category: _categories2.default.openSource,
	  description: 'This simple Mac app gives you a quick way to upload Keynote files to Marvel in just a couple...'
	}, {
	  id: 5,
	  name: "Marvel's Style Guide",
	  url: 'https://marvelapp.com/styleguide',
	  isExternal: true,
	  asset: _assets2.default.styleguideSite,
	  category: _categories2.default.openSource,
	  description: 'As Marvel continues to grow, both as a product and a company, one challenge we are faced...'
	}, {
	  id: 6,
	  name: 'Dashboard',
	  url: 'https://dashboard.marvelapp.com',
	  isExternal: true,
	  asset: _assets2.default.dashboard,
	  category: _categories2.default.openSource,
	  description: 'It syncs with your Marvel account and displays what your team is working in real-time...'
	}, {
	  id: 7,
	  name: 'BotBot',
	  url: 'https://botbot.marvelapp.com',
	  isExternal: true,
	  asset: _assets2.default.botBot,
	  category: _categories2.default.openSource,
	  description: 'This integration combines the power of Marvel with everyone’s favourite messaging...'
	}];
	
	exports.default = items;
	module.exports = exports['default'];

/***/ }),

/***/ 2653:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dashboard@2x-38b0eae5408523ce30b14ec0f87abe7e.jpg";

/***/ }),

/***/ 2654:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/devices@2x-cf8a3c6a7b6b8009be3d7f60ce356b14.jpg";

/***/ }),

/***/ 2655:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/keynote@2x-b6d52aff5f614e0d9b3d64922fc70292.jpg";

/***/ }),

/***/ 2656:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/robot@2x-4572e589bfef31196c182a3d2cdf8f52.jpg";

/***/ }),

/***/ 2657:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sketch@2x-d413e699e6320e86e4ecd99bcb94f69a.jpg";

/***/ }),

/***/ 2658:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/styleguide-site@2x-663b23ccc1db4e559a16fb2eb9351767.jpg";

/***/ }),

/***/ 2659:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/styleguide@2x-aed2aa4db334953c867ef1c697e24142.jpg";

/***/ }),

/***/ 2660:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/userflows@2x-8ba3b14b3894d08c7f68256b9d696179.jpg";

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _SmartLink = __webpack_require__(36);
	
	var _SmartLink2 = _interopRequireDefault(_SmartLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabCard = function (_Component) {
	  _inherits(LabCard, _Component);
	
	  function LabCard() {
	    _classCallCheck(this, LabCard);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.onMouseOver = function () {
	      _this.setState({ isHovered: true });
	    };
	
	    _this.onMouseOut = function () {
	      _this.setState({ isHovered: false });
	    };
	
	    _this.state = {
	      isHovered: false
	    };
	    return _this;
	  }
	
	  LabCard.prototype.render = function render() {
	    var _props = this.props,
	        description = _props.description,
	        name = _props.name,
	        url = _props.url,
	        asset = _props.asset,
	        category = _props.category;
	
	    var hoverTitleColor = this.state.isHovered ? 'slate' : 'black';
	    var opacityClass = (0, _classnames2.default)('transitionDuration-m', {
	      'opacity-80': this.state.isHovered,
	      'opacity-100': !this.state.isHovered
	    });
	    return _react2.default.createElement(
	      'div',
	      { onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut },
	      _react2.default.createElement(
	        _SmartLink2.default,
	        { url: url },
	        _react2.default.createElement(
	          _align2.default,
	          { type: 'center', typeM: 'left' },
	          _react2.default.createElement(
	            'div',
	            { className: opacityClass },
	            _react2.default.createElement(_Image2.default, asset)
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'padding', size: 'm', position: 'topBottom' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'padding', size: 'xs', position: 'bottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'div', size: 'm', weight: 'semibold', color: 'silver' },
	                category && category.name
	              )
	            ),
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'padding', size: 'xs', position: 'bottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                {
	                  tag: 'h3',
	                  weight: 'semibold',
	                  size: 'xxl',
	                  color: hoverTitleColor
	                },
	                name
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l' },
	              _react2.default.createElement(
	                'span',
	                { className: 'whiteSpace-normal truncateText-two' },
	                description
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return LabCard;
	}(_react.Component);
	
	exports.default = LabCard;
	
	
	LabCard.propTypes = {
	  description: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  asset: _propTypes2.default.node.isRequired,
	  category: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Labs;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _IntegrationsCta = __webpack_require__(118);
	
	var _IntegrationsCta2 = _interopRequireDefault(_IntegrationsCta);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _items = __webpack_require__(1239);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _card = __webpack_require__(674);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Labs() {
	  var gridItems = _items2.default.map(function (item) {
	    return _react2.default.createElement(
	      _grid.GridItem,
	      { columnSpan: 3, columnSpanM: 1, key: item.id },
	      _react2.default.createElement(
	        _maxWidth2.default,
	        { value: 387 },
	        _react2.default.createElement(_card2.default, item)
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: _metadata2.default.labs.title,
	      meta: [{
	        name: 'description',
	        content: _metadata2.default.labs.description
	      }, {
	        name: 'keywords',
	        content: _metadata2.default.labs.keywords
	      }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(_Whitespace2.default, { size: 's', sizeS: 'l', sizeM: 'xl' }),
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center', typeM: 'left' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 520 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', weight: 'semibold', size: 'mega' },
	            'Labs'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'topBottom' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 520 },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xxxl', color: 'slate' },
	              'Collection of articles, open source projects and resources made by people at Marvel.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', type: 'padding', position: 'topBottom' },
	          _react2.default.createElement(
	            _grid2.default,
	            { columns: 3, size: 'm', sizeM: 'l', sizeL: 'xl' },
	            gridItems
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_IntegrationsCta2.default, null)
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-labs-index-js-1e7736bc0bb230b8e665.js